import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useViewType } from '../../../../hooks/useViewType';

import { ListOption, ListOptionGroup } from '../../../../design-system';

const CycleMoreOptionsPopup = ({ id, openConfirmArchiveModal, onClose }) => {
    const navigate = useNavigate();

    const { toggleViewType } = useViewType();

    const handleNavToPlaybookEditor = () => {
        toggleViewType();

        const link = `/cycle/${id}`;
        navigate(link);
    };

    const handleAction = (action) => {
        action();
        onClose();
    };

    return (
        <div className="absolute right-0 top-[90%] z-10">
            <ListOptionGroup
                fixedWidth={300}
                listOptions={
                    <>
                        <ListOption
                            leadingIconName="shareBoxLine"
                            text="Go to Client Side"
                            onClick={handleNavToPlaybookEditor}
                        />
                        <ListOption
                            leadingIconName="deleteBin4LineIcon"
                            text="Archive"
                            iconColor="#E95B69"
                            textColor="#E95B69"
                            onClick={() => handleAction(openConfirmArchiveModal)}
                        />
                    </>
                }
                handleClose={onClose}
            />
        </div>
    );
};

export default CycleMoreOptionsPopup;
